import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import { JSX } from 'react'
import { BlockerLayout } from './BlockerLayout'

interface UnconditionalPendingBlockerProps {
  task: AutopilotTaskDto
}

export const UnconditionalPendingBlocker = ({ task }: UnconditionalPendingBlockerProps): JSX.Element => {
  return (
    <BlockerLayout
      task={task}
      title="Commission is Vendor Choice"
      description="Once the Commission Type is updated, you will be able to complete the Unconditional task."
    />
  )
}
